import React from 'react';
import {
  FlatButton,
  Card,
  CardHeader,
  CardActions,
  CardText,
} from 'material-ui';
import Trashcan from 'material-ui/svg-icons/action/delete';
import {
  required,
  translate as t,
} from 'admin-on-rest';
import SingleSelectForm, { SINGLE_SELECT_TYPE } from './SingleSelectForm';
import MultipleSelectForm, { MULTIPLE_SELECT_TYPE } from './MultipleSelectForm';
import BinaryForm, { BINARY_TYPE } from './BinaryForm';
import PairForm, { PAIR_TYPE } from './PairForm';
import SortingForm, { SORTING_TYPE } from './SortingForm';
import ImageSelectForm, { IMAGE_SELECT_TYPE } from './ImageSelectForm';
import BasicTextInput from '../FormInputs/BasicTextInput';
import withConfirmDialog from '../Hocs/withConfirmDialog';

const TRANSLATION_PREFIX = 'resources.quizes.fields.questions';
const TRANSLATION_QUIZ_PREFIX = 'resources.quizes.questions';
const STYLES = {
  cardActions: {
    textAlign: 'right',
  },
};

const FlatButtonWithConfirm = withConfirmDialog(FlatButton);

class QuestionForm extends React.Component {
  state = {
    title: {
      errorText: null,
      touched: false,
    },
  }
  onRemove = () => {
    this.props.onRemove(this.props.id);
  }

  titleOnChange = (ev) => {
    this.change('title', ev.target.value);
    this.setState({
      title: {
        touched: true,
        errorText: required(ev.target.value, null, this.props),
      },
    });
  }
  timeOnChange = (ev) => {
    this.change('time', ev.target.value);
  }
  levelOnChange = (ev) => {
    this.change('level', ev.target.value);
  }

  change = (key, value) => {
    const delta = {};
    delta[key] = value;
    this.props.onChange(delta, this.props.id);
  }


  render() {
    const {
      title, time, level, headerTitle,
      type, translate,
    } = this.props;
    const removeTitle = `${translate('remove')}${title ? ` "${title}"` : ''}`;
    let subQuestion;
    switch (type) {
      case SINGLE_SELECT_TYPE:
        subQuestion = (<SingleSelectForm {...this.props} />);
        break;
      case MULTIPLE_SELECT_TYPE:
        subQuestion = (<MultipleSelectForm {...this.props} />);
        break;
      case BINARY_TYPE:
        subQuestion = (<BinaryForm {...this.props} />);
        break;
      case PAIR_TYPE:
        subQuestion = (<PairForm {...this.props} />);
        break;
      case SORTING_TYPE:
        subQuestion = (<SortingForm {...this.props} />);
        break;
      case IMAGE_SELECT_TYPE:
        subQuestion = (<ImageSelectForm {...this.props} />);
        break;
      default:
        break;
    }
    return (
      <Card expandable>
        <CardHeader
          title={headerTitle}
          actAsExpander
          showExpandableButton
        />
        <CardText expandable>
          <BasicTextInput
            type="text"
            value={title}
            onTouch={this.titleOnChange}
            errorText={this.state.title.touched && this.state.title.errorText}
            floatingLabelText={translate(`${TRANSLATION_PREFIX}.title`)}
          />
          <BasicTextInput
            type="number"
            value={time}
            onChange={this.timeOnChange}
            floatingLabelText={translate(`${TRANSLATION_PREFIX}.time`)}
          />
          <BasicTextInput
            type="text"
            value={level}
            onChange={this.levelOnChange}
            floatingLabelText={translate(`${TRANSLATION_PREFIX}.level`)}
          />
          { subQuestion }
        </CardText>
        <CardActions expandable style={STYLES.cardActions}>
          <FlatButtonWithConfirm
            icon={<Trashcan />}
            label={removeTitle}
            confirmationTitle={removeTitle}
            confirmationText={translate(`${TRANSLATION_QUIZ_PREFIX}.removeConfirm`)}
            submitText={translate('remove')}
            onClick={this.onRemove}
            primary
          />
        </CardActions>
      </Card>
    );
  }
}

export default t(QuestionForm);
